import instance from "./instance";

const NewsAPINew = (params) => {
  return instance.get(`/news?${params}`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default NewsAPINew;
